import { useQuery } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useGetProjectInfo = (projectId) => {
  const data = useQuery(
    ["projectInfo", projectId],
    () =>
      axiosClient.get(
        `/Project/GetProjectInformation?projectId=${projectId}`
      ),
  );

  return data;
};
export default useGetProjectInfo;